import SuppliersResult from './ResultPage';

export default SuppliersResult;
